<mat-dialog-content class="fullscreen-dialog">
  <mat-toolbar class="fullscreen-toolbar" color="warn">
    Cancel Recall
  </mat-toolbar>
  <div class="container">
    <br />
    <p>Are you sure you want to cancel this recall?</p>
    <p class="warning-text">
      <i class="fa-solid fa-triangle-exclamation"></i>
      <strong>Warning:</strong> The operative may still receive a recall notification even after cancellation.
    </p>
  </div>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button (click)="dialogRef.close(false)" mat-flat-button
          type="button">{{ 'scheduler.general.cancel' | translate }}
  </button>
  <button (click)="dialogRef.close(true)" color="warn" mat-flat-button
          type="button">Cancel Recall
  </button>
</mat-dialog-actions>
